import { call, takeLatest } from 'redux-saga/effects';

import apiConfig from '@constants/apiConfig';
import { sendRequest } from '@services/api';
import { accountActions } from '@store/actions';
import { processAction } from '@store/utils';

// Port từ ra-log-monitor-cms/source/src/sagas/account.js.
//
// Đăng nhập HAI BƯỚC bằng OTP qua `requestToken` (KHÔNG có TOTP/QR như mreport, KHÔNG có
// verify-credential như license):
//   B1 LOGIN     -> POST /v1/account/login   -> trả nguyên responseData (chứa data.requestToken)
//   B2 LOGIN_OTP -> POST /v1/account/verify_otp { otp, requestToken }
//                   -> thành công thì gọi tiếp GET /v1/account/profile bằng token vừa nhận
//                   -> trả { token, id, avatar, logo, username, fullName, kind, isSuperAdmin, permissions }
//
// F1: nguồn có nhánh `apiConfig.employee.getEmployeeProfile` cho kind != ADMIN, nhưng repo này
//     không khai `employee` trong apiConfig -> nhánh đó CRASH ở bản cũ. Chỉ port nhánh ADMIN.

const getProfileSaga = (payload) => processAction(apiConfig.account.getProfile, payload);

function* fetchAdminProfile(token) {
    return yield call(sendRequest, { ...apiConfig.account.getAdminProfile, authorization: `Bearer ${token}` }, {});
}

// LOGIN (bước 1): trả NGUYÊN responseData để component đọc `data.requestToken`
function* loginSaga({ payload: { params, onCompleted, onError } }) {
    try {
        const result = yield call(sendRequest, apiConfig.account.login, { data: params });
        if (result?.data?.data) {
            onCompleted?.({ ...result.data });
        } else {
            onError?.(result?.data);
        }
    } catch (error) {
        console.log(error);
        onError?.(error?.response?.data || error);
    }
}

// LOGIN_OTP (bước 2): verify_otp -> profile
function* loginOtpSaga({ payload: { params, onCompleted, onError } }) {
    try {
        const result = yield call(sendRequest, apiConfig.account.loginOtp, { data: params });
        if (result?.data?.result) {
            const token = result.data.data?.token;
            const profileRes = yield fetchAdminProfile(token);
            if (profileRes?.data?.result) {
                const pd = profileRes.data.data;
                let permissions = [];
                if (pd.group && pd.group.permissions) {
                    permissions = pd.group.permissions.map((permission) => permission.action);
                }
                onCompleted?.({
                    token,
                    id: pd.id,
                    avatar: pd.avatar,
                    logo: pd.logoPath,
                    username: pd.username,
                    fullName: pd.fullName,
                    kind: pd.kind,
                    isSuperAdmin: pd.isSuperAdmin,
                    permissions,
                });
            } else {
                onError?.(result.data);
            }
        } else {
            onError?.(result?.data);
        }
    } catch (error) {
        console.log(error);
        onError?.(error?.response?.data || error);
    }
}

const sagas = [
    takeLatest(accountActions.login.type, loginSaga),
    takeLatest(accountActions.loginOtp.type, loginOtpSaga),
    takeLatest(accountActions.getProfile.type, getProfileSaga),
];

export default sagas;
